export default __webpack_public_path__ + "static/barfplan-blog-promo-small@3x-112bf4bfacee951636431872773ed8a8.png";